import { render, staticRenderFns } from "./TenderListBreakdownRow.vue?vue&type=template&id=64f5f882&"
import script from "./TenderListBreakdownRow.vue?vue&type=script&lang=js&"
export * from "./TenderListBreakdownRow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports